<template>
  <div class="container">
    <BaseFrame :infos="infos" :idText="idText" @clear="clear" :able='able'
      @cancel="$router.push({ name: 'storeAccountList'})" saveText="保存" :saveLoading='saveLoading'
      :cancelText='isMyOwnInfo?"":"取消"'
      @save="submit('storeUserForm')">
      <div slot="content">
        <lk-form :model="storeUserForm" label-position="right" :label-width="130"
          :rules="ruleValidate" ref="storeUserForm">
          <div class="cardContainer">
            <lk-card title="基本信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="账户名:" prop="sysUser.phone">
                    <lk-input v-if="able" :maxlength="11" placeholder="一旦提交不可修改，请您输入正确手机号"
                      :disabled="!!$route.params.id" v-model.trim="storeUserForm.sysUser.phone">
                    </lk-input>
                    <span v-else>{{storeUserForm.sysUser.phone}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="姓名:" prop="sysUser.name">
                    <lk-input v-if="able" :maxlength="50" placeholder="请输入"  :disabled='isMyOwnInfo'
                      v-model.trim="storeUserForm.sysUser.name">
                    </lk-input>
                    <span v-else>{{storeUserForm.sysUser.name}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="性别:" class="inline">
                    <lk-radio-group v-if="able" v-model.trim="storeUserForm.sysUser.gender">
                      <lk-radio :label="1">男</lk-radio>
                      <lk-radio :label="2">女</lk-radio>
                    </lk-radio-group>
                    <span v-else>{{gender[storeUserForm.sysUser.gender]}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="邮箱:" prop="sysUser.email">
                    <lk-input v-if="able" :maxlength="100" placeholder="请输入"
                      v-model.trim="storeUserForm.sysUser.email"></lk-input>
                    <span v-else>{{storeUserForm.sysUser.email}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="有效证件类型:">
                    <lk-select v-if="able" v-model.trim="storeUserForm.sysUser.cardType">
                      <lk-option v-for="item in cardTypeList"
                      :key="item.key"
                      :value='item.key'> {{item.value}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{CARDTYPE[storeUserForm.sysUser.cardType]}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" >
                  <lk-form-item label="证件号码:" prop="sysUser.idCard">
                    <lk-input v-if="able" :maxlength="100" placeholder="请输入"
                      v-model.trim="storeUserForm.sysUser.idCard">
                    </lk-input>
                    <span v-else>{{storeUserForm.sysUser.idCard}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="执业范围:" prop="sysUser.practiceArea">
                    <lk-input v-if="able" :maxlength="100" placeholder="请输入"
                      v-model.trim="storeUserForm.sysUser.practiceArea">
                    </lk-input>
                    <span v-else>{{storeUserForm.sysUser.practiceArea}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="职称:" prop="sysUser.posTitle">
                    <lk-input v-if="able" :maxlength="40" placeholder="请输入"
                      v-model.trim="storeUserForm.sysUser.posTitle">
                    </lk-input>
                    <span v-else>{{storeUserForm.sysUser.posTitle}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="职务:" prop="sysUser.posDuty">
                    <lk-input v-if="able" :maxlength="70" placeholder="请输入"
                      v-model.trim="storeUserForm.sysUser.posDuty">
                    </lk-input>
                    <span v-else>{{storeUserForm.sysUser.posDuty}}</span>
                  </lk-form-item>
                </lk-col>
                </lk-row>
                <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="职业注册地:" prop="sysUser.posRegistePlace">
                    <lk-input v-if="able" :maxlength="300" placeholder="请输入"
                      v-model.trim="storeUserForm.sysUser.posRegistePlace">
                    </lk-input>
                    <span v-else>{{storeUserForm.sysUser.posRegistePlace}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="处方有效标志:">
                    <lk-select v-if="able" clearable v-model.trim="storeUserForm.sysUser.prescriptionStatus">
                      <lk-option v-for="item in prescriptionStatusList"
                      :key="item.key"
                      :value='item.key'> {{item.value}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{PRESCRIPTIONSTATUS[storeUserForm.sysUser.prescriptionStatus]}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="开始执业时间:">
                    <lk-DatePicker
                    v-if="able"
                    style="width:100%;"
                    class="item"
                    v-model.trim="storeUserForm.sysUser.practiceStartTime">
                  </lk-DatePicker>
                    <span v-else>{{storeUserForm.sysUser.practiceStartTime}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                <lk-form-item label="结束执业时间:">
                  <lk-DatePicker
                    v-if="able"
                    style="width:100%;"
                    class="item"
                    :options="createTimeEndOptions()"
                    v-model.trim="storeUserForm.sysUser.practiceEndTime">
                  </lk-DatePicker>
                    <span v-else>{{storeUserForm.sysUser.practiceEndTime}}</span>
                </lk-form-item>
              </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="角色信息">
              <div v-for="(item,index) in storeUserForm.sysPositionList" :key="index">

              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="所属门店:"  :prop="'sysPositionList'+index+'Name'">
                    <lk-select v-if="isHQ && able" filterable @on-change="handleMutliSysStoreList($event,index)" v-model="storeUserForm.sysPositionList[index].sysStore.id">
                      <lk-option v-for="item in sysStoreList" :key="item.id"
                      :value='item.id'>{{item.name}}</lk-option>
                    </lk-select>
                    <!-- <span v-else-if='storeUserForm.sysPositionList[index].sysStore.name'>{{storeUserForm.sysPositionList[index].sysStore.name||}}</span> -->
                    <span v-else-if="sysStoreList.length">{{item.sysStore.name||sysStoreList[0].name}}</span>
                  <span :class="{'affix':true,'affix-long':index>0}" v-show="isHQ&& able">

                  <lk-button icon='md-add' class="mr8" @click="addSysStore(index)"></lk-button>
                  <lk-button v-if="index>0" icon='md-remove'  @click="removeSysStore(index)"></lk-button>
                  </span>
                    <!-- <span>{{storeUserForm.sysPositionList[index].sysStore.name}}</span> -->
                  </lk-form-item>
                </lk-col>
                <!-- <lk-col>
                </lk-col> -->


              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="20">
                  <lk-form-item v-if="storeUserForm.sysPositionList" label="门店角色:" :prop="'sysPositionList'+index" class="formatCheckbox">
                    <lk-checkbox-group v-if="able" v-model.trim="storeUserForm.sysPositionList[index].roleList">
                      <lk-checkbox v-for="(item,i) in storeRoles" :key="i" :label="item.id"
                        :checked="item.checked" :disabled="item.disabled">
                        {{item.name}}
                      </lk-checkbox>
                    </lk-checkbox-group>
                        <span v-else>{{storeUserForm.sysPositionList[index]&&storeUserForm.sysPositionList[index].roleStrList}}</span>
                    <!-- <span>{{storeUserForm.sysPositionList[index]}}</span> -->
                  </lk-form-item>
                </lk-col>
              </lk-row>
              </div>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="专业信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="学历:">
                    <lk-select v-if="able" clearable v-model.trim="storeUserForm.sysUser.education">
                      <lk-option v-for="(item,index) in education.slice(1)" :value="index+1" :key="index">
                        {{item}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{education[storeUserForm.sysUser.education]}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="是否药学:">
                     <lk-radio-group v-if="able" v-model.trim="storeUserForm.sysUser.majorType">
                      <lk-radio v-for="(item,i) in majorTypes" :key="i" :label="i*1"
                        >
                        {{item}}
                      </lk-radio>
                    </lk-radio-group>
                    <span v-else>{{majorTypes[storeUserForm.sysUser.majorType]}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="专业:">

                    <lk-input v-if="able" :maxlength="10" placeholder="请输入"
                      v-model.trim="storeUserForm.sysUser.major">
                    </lk-input>
                    <span v-else>{{majorStr}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="药师资格证号:" prop="sysUser.apothecaryCode">
                    <lk-input v-if="able" :maxlength="40" placeholder="请输入"
                      v-model.trim="storeUserForm.sysUser.apothecaryCode">
                    </lk-input>
                    <span v-else>{{storeUserForm.sysUser.apothecaryCode}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1" v-if="needShowApp">
                  <lk-form-item label="是否小程序展示:">
                     <lk-radio-group v-if="able" v-model.trim="storeUserForm.sysUser.appShow">
                      <lk-radio v-for="(item,i) in actionsForWeApp" :key="i" :label="i*1">
                        {{item}}
                      </lk-radio>
                    </lk-radio-group>
                    <span v-else>{{actionsForWeApp[storeUserForm.sysUser.appShow || 2]}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="证件信息">
              <lk-row :gutter="16">
                <lk-col span="7" class="backGroundCard">
                  <lk-form-item prop='sysUser.educationUrl'>
                    <div class="label withPic">
                      <label>学历证件:</label>
                    </div>
                    <Uploader :able="able" v-model="storeUserForm.sysUser.educationUrl">
                    </Uploader>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1" class="backGroundCard">
                  <lk-form-item prop='sysUser.apothecaryUrl'>
                    <div class="label withPic">
                      <label>药师证件:</label>
                    </div>
                    <Uploader :able="able" v-model="storeUserForm.sysUser.apothecaryUrl">
                    </Uploader>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">

                <lk-col span="7" class="backGroundCard">
                  <lk-col span="24">
                    <lk-form-item prop="sysUser.pharmacistUrl">
                      <div class="label withPic">
                        <label>执业药师注册证件:</label>
                      </div>
                      <Uploader :able="able" v-model="storeUserForm.sysUser.pharmacistUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="24">
                    <lk-form-item label="有效日期:" prop="sysUser.pharmacistExpiry"
                      ref="pharmacistExpiry">
                      <expire-picker :able='able' :editable='able'
                        v-model.trim="storeUserForm.sysUser.pharmacistExpiry" />
                    </lk-form-item>
                  </lk-col>
                </lk-col>
                <lk-col span="7" offset='1' class="backGroundCard">

                  <lk-col span="24">
                    <lk-form-item prop="sysUser.medicalTableUrl">
                      <div class="label withPic">
                        <label>体检表:</label>
                      </div>
                      <Uploader :able="able" v-model="storeUserForm.sysUser.medicalTableUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="24">
                    <lk-form-item label="有效日期:" prop="sysUser.medicalTableExpiry"
                      :label-width="137">
                      <expire-picker :able='able'
                        v-model.trim="storeUserForm.sysUser.medicalTableExpiry" />
                    </lk-form-item>
                  </lk-col>
                </lk-col>
              </lk-row>

            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
    <DTPModal
      v-model="showClear"
      @confirm="confirmClear"
      content="重置将取消当前所做更改。"
    ></DTPModal>
     <DTPModal
      v-model="showTest"
      @confirm="importInfo"
      @handleCancel="confirmClear"
      content="此账号已有总部权限，是否对此账号配置门店权限？"
      type="alert"
    ></DTPModal>
  </div>
</template>
<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import Uploader from '@/components/Uploader.vue';
import utils from '@/libs/utils';
import DTPModal from '@/components/DTPModal.vue';
import expirePicker from '@/components/expireInfo/expirePicker';
import system from '../../services/system';
// import mapState from '../../mixins/mapState';

export default {
  name: 'storeAccountInfo',
  components: {
    BaseFrame,
    Uploader,
    DTPModal,
    expirePicker,
  },

  data() {
    const checkPhone = (rule, value, callback) => {
      // this.saveLoading && callback();
      if (this.$route.name === 'storeAccountEdit' || this.saveLoading) {
        callback();
      } else {
        this.$store.commit('setDisableLoading', true);
        system.storePhoneCheck({ phone: value }).then((res) => {
          if (res.data.status === 200) {
            this.tempInfo = res.data.data;
            if (this.tempInfo) {
              this.showTest = true;
            }
            callback();
          } else {
            callback(new Error(res.data.error));
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    };
    const checkDate = (rule, value, callback) => {
      // 如果非必填，放行
      // 如果必填，校验是否为 date
      const required = rule.required;
      if (!required) {
        callback();
      } else if (value) {
        callback();
      } else {
        callback(new Error('日期必填'));
      }
    };

    return {
      needShowApp: false,
      showTest: false,
      tempInfo: null,
      sysStoreList: [],
      able: true,
      isAdd: true,
      showClear: false,
      gender: ['', '男', '女'],
      education: ['', '初中', '高中', '专科', '本科', '硕士研究生', '博士研究生'],
      majorTypes: {
        1: '药学相关',
        2: '非药学相关',
      },
      actionsForWeApp: {
        1: '是',
        2: '否',
      },
      storeRoles: [],
      PRESCRIPTIONSTATUS: {
        1: '已审核',
        2: '未审核',
        3: '无效',
      },
      prescriptionStatusList: [
        {
          key: 1,
          value: '已审核',
        },
        {
          key: 2,
          value: '未审核',
        },
        {
          key: 3,
          value: '无效',
        },
      ],
      CARDTYPE: {
        1: '居民身份证',
        2: '港澳通行证',
        3: '台湾通行证',
        4: '护照',
      },
      cardTypeList: [
        {
          key: 1,
          value: '居民身份证',
        },
        {
          key: 2,
          value: '港澳通行证',
        },
        {
          key: 3,
          value: '台湾通行证',
        },
        {
          key: 4,
          value: '护照',
        },
      ],
      idText: '',
      infos: null,
      mutliSysStoreList: [],
      saveLoading: false,
      storeUserForm: {
        sysUser: {
          cardType: 1,
          id: '',
          prescriptionStatus: '',
          practiceArea: '',
          posTitle: '',
          posDuty: '',
          posRegistePlace: '',
          practiceStartTime: '',
          practiceEndTime: '',
          phone: '',
          email: '',
          name: '',
          gender: 1,
          idCard: '',
          education: '',
          major: '', // 专业
          educationUrl: '', // 学历证件
          apothecaryUrl: '', // 药师证件
          apothecaryCode: '', // 药师资格证号
          pharmacistUrl: '', // 执业药师注册证件
          pharmacistExpiry: '', // 体检表过期时间
          medicalTableUrl: '', // 体检表
          medicalTableExpiry: '',
          appShow: 2, // 是否在小程序展示
        },
        roleIdList: [],
        sysPositionList: [
          { roleList: [], sysStore: {} },
          // { roleList: [], sysStore: { name: 'test' } },
        ],
      },
      ruleValidate: {
        'sysUser.phone': [
          { required: true, message: '请输入账户名', trigger: 'blur' },
          { validator: utils.validate.cellPhoneValidator, message: '请输入正确手机号码', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        'sysUser.name': [
          { required: true, message: '请输入姓名', trigger: 'change' },
        ],
        'sysUser.idCard': [
          { validator: utils.validate.IDValidator, idtype: 1, trigger: 'blur' },
        ],
        'sysUser.email': [
          { trigger: 'blur', message: '请输入正确邮箱号', type: 'email' },
        ],
        'sysUser.posDuty': [
          { validator: utils.validate.posDutyValidator, trigger: 'blur' },
        ],
        'sysUser.practiceArea': [
          { validator: utils.validate.practiceAreaValidator, trigger: 'blur' },
        ],
        'sysUser.posTitle': [
          { validator: utils.validate.posTitleValidator, trigger: 'blur' },
        ],
        'sysUser.posRegistePlace': [
          { validator: utils.validate.posRegistePlaceValidator, trigger: 'blur' },
        ],
        // roleIdList: [
        //   {
        //     required: true, message: '请选择角色信息', trigger: 'blur', type: 'array',
        //   },
        // ],
        'sysUser.apothecaryUrl': [
          { required: false, message: '药师证件必填', trigger: 'change' },
        ],
        'sysUser.apothecaryCode': [
          { required: false, message: '药师资格证号', trigger: 'change' },
        ],
        'sysUser.pharmacistUrl': [
          { required: false, message: '执业药师注册证必填', trigger: 'change' },
        ],
        'sysUser.pharmacistExpiry': [
          {
            required: false, message: '执业药师注册证有效期必填', trigger: 'change', validator: checkDate,
          },
        ],
        'sysUser.medicalTableUrl': [
          { required: false, message: '体检表必填', trigger: 'change' },
        ],
        'sysUser.medicalTableExpiry': [
          {
            required: false, message: '体检表有效期必填', trigger: 'change', validator: checkDate,
          },
        ],
      },
    };
  },
  methods: {
    importInfo() {
      this.storeUserForm.sysUser = this.tempInfo;
      this.showTest = false;
    },
    getSysStoreList() {
      system.getBelongStores().then((res) => {
        if (res.data.status === 200) {
          // const rightList = [];
          this.sysStoreList = res.data.data;
          // this.user.sysStoreList.forEach((item) => {
          //   rightList.push(item.id);
          // });
          // for (let i = 0; i < this.sysStoreList.length; i++) {
          //   if (rightList.includes(this.sysStoreList[i].id)) {
          //     this.sysStoreList.splice(i, 1);
          //   }
          // }

          this.handleMutliSysStoreList();
          // this.storeUserForm.roleStrList = roleStrList.join(', ');
          // this.storeUserForm.sysUser = temp.sysUser;
          // this.storeUserForm.sysUser.pharmacistExpiry = new Date(temp.sysUser.pharmacistExpiry);
          // this.storeUserForm.sysUser.medicalTableExpiry = new Date(temp.sysUser.medicalTableExpiry);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addSysStore(i) {
      this.storeUserForm.sysPositionList.push(
        {
          sysStore: {}, roleList: [],
        },
      );
    },
    createTimeEndOptions() {
      const vm = this;
      return {
        disabledDate(time) {
          if (time && vm.storeUserForm.sysUser.practiceStartTime) {
            return time.getTime() < vm.storeUserForm.sysUser.practiceStartTime.getTime();
          }
        },
      };
    },
    removeSysStore(i) {
      this.storeUserForm.sysPositionList.splice(i, 1);
    },
    submit(name) {
      // if (this.storeUserForm.sysUser.pharmacistExpiry && utils.isExpired(this.storeUserForm.sysUser.pharmacistExpiry)) {
      //   this.$Message.error('证书已过期，请重新提交');
      //   return;
      // }
      // if (this.storeUserForm.sysUser.medicalTableExpiry && utils.isExpired(this.storeUserForm.sysUser.medicalTableExpiry)) {
      //   this.$Message.error('证书已过期，请重新提交');
      //   return;
      // }
      this.saveLoading = true;
      this.$refs[name].validate((valid) => {
        this.saveLoading = valid;
        if (valid) {
          const temp = utils.deepClone(this.storeUserForm);

          // 如果不需要小程序展示，将 appShow 设置为 2
          if (!this.needShowApp) {
            temp.sysUser.appShow = 2;
          }
          if (!temp.sysPositionList[0].sysStore.id) {
            temp.sysPositionList[0].sysStore.id = this.sysStoreList[0].id;
          }
          for (const key in temp.sysUser) {
            if (key.includes('Exprie')) {
              if (temp.sysUser[key]) {
                temp.sysUser[key] = (new Date(temp.sysUser[key])).getTime();
              }
            }
            if (key.includes('practiceStartTime')) {
              if (temp.sysUser[key]) {
                temp.sysUser[key] = (new Date(temp.sysUser[key])).getTime();
              }
            }
            if (key.includes('practiceEndTime')) {
              if (temp.sysUser[key]) {
                temp.sysUser[key] = (new Date(temp.sysUser[key])).getTime();
              }
            }
          }
          if (['storeAccountEdit', 'personalStoreEdit'].includes(this.$route.name)) {
            system.storeUserUpdate(temp).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('保存成功');
                setTimeout(() => {
                  this.$router.push({ name: 'storeAccountList' });
                }, 1000);
              } else {
                this.$Message.error(res.data.error);
                this.saveLoading = false;
              }
            }).catch((err) => {
              this.saveLoading = false;
              utils.handleError(err);
            });
          } else {
            // this.saveLoading = true;
            system.storeUserSave(temp).then((res) => {
              if (res.data.status === 200) {
                this.$Message.info({
                  duration: 10,
                  closable: true,
                  content: res.data.data.password ? `保存成功，新增用户工号为：${res.data.data.uid}    密码为：${res.data.data.password}` : '账户多类型设置成功，原密码保持不变',
                });
                this.$router.push({ name: 'storeAccountList', params: { create: true } });
              } else {
                this.$Message.error(res.data.error);
                this.saveLoading = false;
              }
            }).catch((err) => {
              this.saveLoading = false;
              utils.handleError(err);
            });
          }
        }
      });
    },
    // 获取角色信息
    getRoleInfos() {
      system.storeListEnable({ type: 2, page: 1, size: 10000 }).then((res) => {
        const { data } = res.data;
        if (res.data.status === 200) {
          data.list.forEach((item) => {
            if (!this.isAdd && this.storeUserForm.roleIdList.includes(item.id)) {
              item.checked = true;
            }
            // if (item.id === 12 && this.isAdd) {
            // if ([17, 18].includes(this.currentUserRole)) {
            //   this.storeUserForm.roleIdList = [12];


            //   item.checked = true;
            // }
            // item.disabled = true;
            // }
            if (item.id === 12 && !this.isHQ) {
              // if ([12].includes(this.currentUserRole)) {
              item.disabled = true;
              // }
            }
            if (this.isMyOwnInfo) {
              item.disabled = true;
            }
          });
          this.storeRoles = data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInfos(id) {
      return new Promise((resolve) => {
        system.storeUserInfo({ id }).then((res) => {
          if (res.data.status === 200) {
            const temp = Object.assign({}, res.data.data);
            const modifiedRecord = {};
            this.idText = '账户ID';
            modifiedRecord.id = temp.sysUser.id;
            modifiedRecord.createUserName = temp.sysUser.createUserName;
            modifiedRecord.createTime = utils.formatTime(temp.sysUser.createTime);
            modifiedRecord.modifiedUserName = temp.sysUser.modifiedUserName;
            modifiedRecord.modifiedTime = utils.formatTime(temp.sysUser.modifiedTime);
            this.infos = modifiedRecord;

            // 前面部分，添加服务端没有的默认值
            this.storeUserForm.sysUser = {
              ...{ appShow: 2 },
              ...temp.sysUser,
            };
            if (!this.storeUserForm.sysUser.cardType) {
              this.storeUserForm.sysUser.cardType = 1;
            }
            this.storeUserForm.sysUser.practiceEndTime = this.able ? utils.formatTime(temp.sysUser.practiceEndTime) : utils.formatTime(temp.sysUser.practiceEndTime, 'YYYY-MM-DD');
            this.storeUserForm.sysUser.practiceStartTime = this.able ? utils.formatTime(temp.sysUser.practiceStartTime) : utils.formatTime(temp.sysUser.practiceStartTime, 'YYYY-MM-DD');
            this.storeUserForm.sysPositionList = temp.sysPositionList;
            this.storeUserForm.sysPositionList.forEach((item) => {
              const ids = item.roleIdList;
              const roleList = item.roleList;
              item.roleList = item.roleIdList;
              const roleStrList = [];
              for (const el of roleList) {
                if (ids.includes(el.id)) {
                  roleStrList.push(el.name);
                }
              }
              item.roleStrList = roleStrList.join(', ');
            });


            this.storeUserForm.sysUser.pharmacistExpiry = temp.sysUser.pharmacistExpiry;
            this.storeUserForm.sysUser.medicalTableExpiry = temp.sysUser.medicalTableExpiry;
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    confirmClear() {
      this.$refs.storeUserForm.resetFields(); // 重置表单
      if (this.$route.name !== 'storeAccountAdd') {
        this.getInfos(this.$route.params.id).then(() => {
          this.getRoleInfos();
        });
      } else {
        this.storeUserForm = {
          sysUser: {
            id: '',
            phone: '',
            email: '',
            name: '',
            gender: 1,
            idCard: '',
            cardType: '',
            practiceArea: '',
            posTitle: '',
            posDuty: '',
            posRegistePlace: '',
            prescriptionStatus: '',
            practiceStartTime: '',
            practiceEndTime: '',
            education: '',
            major: '', // 专业
            educationUrl: '', // 学历证件
            apothecaryUrl: '', // 药师证件
            pharmacistUrl: '', // 执业药师注册证件
            pharmacistExpiry: '', // 体检表过期时间
            medicalTableUrl: '', // 体检表
            medicalTableExpiry: '',
          },
          roleIdList: [],
          sysPositionList: [
            { roleList: [], sysStore: {} },

          ],
        };
        this.getRoleInfos();
      }
      this.showClear = false;
    },
    clear() {
      this.showClear = true;
    },
    hasRoleIds(target, test) {
      let result = false;
      test.forEach((id) => {
        if (target.includes(id)) {
          result = true;
        }
      });
      return result;
    },
    handleMutliSysStoreList(val, index) {
      const selected = [];
      this.storeUserForm.sysPositionList.forEach((item) => {
        selected.push(item.sysStore.id);
      });
      const temp = [...new Set(selected)];
      if (temp.length !== selected.length) {
        this.storeUserForm.sysPositionList[index].sysStore.id = null;
        this.$Message.error('请选择不同的门店');
      }
      this.$nextTick(() => {
        this.storeUserForm[`sysPositionList${index}Name`] && this.$refs.storeUserForm.validateField(`sysPositionList${index}Name`);
      });

      // const temp = [];
      // const length = this.storeUserForm.sysPositionList.length;
      // for (let i = 0; i < length; i++) {
      //   temp[i] = [];
      //   this.sysStoreList.forEach((item) => {
      //     seleted.includes(item.id) || temp[i].push(item);
      //   });
      // }


      // this.mutliSysStoreList = temp;
    },
    handlRequired() {
      console.log(utils.deepClone(this.storeUserForm.sysPositionList));

      this.storeUserForm.sysPositionList.forEach((item, index) => {
        this.storeUserForm[`sysPositionList${index}`] = utils.deepClone(item.roleList);
        if (this.isHQ) {
          this.ruleValidate[`sysPositionList${index}Name`] = [{
            required: true, message: '请选择所属门店', trigger: 'change', type: 'number',
          }];
          this.storeUserForm[`sysPositionList${index}Name`] = utils.deepClone(item.sysStore.id);
          // this.storeUserForm[`sysPositionList${index}Name`] && this.$refs.storeUserForm.validateField(`sysPositionList${index}Name`);
        }
        this.ruleValidate[`sysPositionList${index}`] = [
          {
            required: true, message: '请选择角色信息', trigger: 'blur', type: 'array',
          },
        ];
      });
    },
  },
  mounted() {
    this.getSysStoreList();
    this.able = this.$route.name !== 'storeAccountInfo';


    if (this.$route.name !== 'storeAccountAdd') {
      this.getInfos(this.$route.params.id).then(() => {
        this.getRoleInfos();
      });
      this.isAdd = false;
    } else {
      this.getRoleInfos();
    }
  },
  watch: {
    storeUserForm: {
      handler(val) {
        this.handlRequired();
        let roleIds = [];
        this.storeUserForm.sysPositionList.forEach((item, index) => {
          roleIds = roleIds.concat(item.roleList);
        });

        const ids = [...new Set(roleIds)];

        // 控制 是否小程序展示字段
        this.needShowApp = this.hasRoleIds(ids, [3, 1, 20]);

        if (this.storeUserForm.sysUser.cardType === 1) {
          this.ruleValidate['sysUser.idCard'][0].idtype = 1;
        }
        if (this.storeUserForm.sysUser.cardType === 2) {
          this.ruleValidate['sysUser.idCard'][0].idtype = 2;
        }
        if (this.storeUserForm.sysUser.cardType === 3) {
          this.ruleValidate['sysUser.idCard'][0].idtype = 3;
        }
        if (this.storeUserForm.sysUser.cardType === 4) {
          this.ruleValidate['sysUser.idCard'][0].idtype = 4;
        }
        // 药师证
        // 药师，企业负责人，中药药师必填
        if (this.hasRoleIds(ids, [3, 1, 20])) {
          this.ruleValidate['sysUser.apothecaryUrl'][0].required = true;
        } else {
          this.ruleValidate['sysUser.apothecaryUrl'][0].required = false;
        }
        // 执业药师注册证
        // 药师，企业负责人，中药药师必填
        if (this.hasRoleIds(ids, [3, 1, 20])) {
          this.ruleValidate['sysUser.pharmacistUrl'][0].required = true;
          this.ruleValidate['sysUser.pharmacistExpiry'][0].required = true;
        } else {
          this.ruleValidate['sysUser.pharmacistUrl'][0].required = false;
          this.ruleValidate['sysUser.pharmacistExpiry'][0].required = false;
        }
        // 体检表
        // 营业员，收银员，验收员，收货员，采购员，养护员，药师，中药药师，质量负责人，企业负责人必填
        if (this.hasRoleIds(ids, [9, 8, 7, 6, 5, 4, 3, 20, 2, 1])) {
          this.ruleValidate['sysUser.medicalTableUrl'][0].required = true;
          this.ruleValidate['sysUser.medicalTableExpiry'][0].required = true;
        } else {
          this.ruleValidate['sysUser.medicalTableUrl'][0].required = false;
          this.ruleValidate['sysUser.medicalTableExpiry'][0].required = false;
        }

        // 是否小程序
        if (this.storeUserForm.sysUser.appShow == 1 && this.needShowApp) {
          this.ruleValidate['sysUser.apothecaryCode'][0].required = true;
        } else {
          this.ruleValidate['sysUser.apothecaryCode'][0].required = false;
        }

        this.$refs.storeUserForm.fields.forEach((field) => {
          field.setRules();
        });
      },
      deep: true,
    },
  },
  computed: {
    majorStr() {
      const res = this.storeUserForm.sysUser.major;
      // if (this.majorTypes[this.storeUserForm.sysUser.majorType]) {
      //   res = this.majorTypes[this.storeUserForm.sysUser.majorType] + res;
      // }
      return res;
    },
    isHQ() {
      return this.user.roleType !== 2;
    },
    user() {
      return this.$store.state.user;
    },
    isMyOwnInfo() { // 判定是否为我的资料
      return this.$route.name === 'personalStoreEdit';
    },
    // ...mapState(['user']),
    // sysStoreList() {
    //   const temp = this.$store.state.user.sysStoreList || [];
    //   for (let i = 0; i < temp.length; i++) {
    //     const el = temp[i];

    //     el.id === 1 && temp.splice(i, 1);
    //   }
    //   return temp;
    // },
    currentUserRole() {
      const currentRoleIds = [];
      this.$store.state.user.roles.forEach((item) => {
        currentRoleIds.push(item.id);
      });
      if (currentRoleIds.includes(12)) { // 门店管理员
        return 12;
      }
      if (currentRoleIds.includes(17)) { // 系统管理员
        return 17;
      }
      if (currentRoleIds.includes(18)) { // 总部管理员
        return 18;
      }
      return 0;
    },
  },
};
</script>
<style lang="less" scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
  .affix{
    float:right;
    margin-right: -60px;
    padding-top: 1px
  }
  .affix-long{
    margin-right: -106px;

  }
</style>
